export enum ApiErrorLabel {
  Ok = 'Success',
  Accepted = 'Accepted',
  BadRequest = 'Bad Request',
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  NotFound = 'Not Found',
  MethodNotAllowed = 'MethodNotAllowed',
  RequestTimeout = 'Request Timeout',
  InternalServerError = 'Internal Server Error',
  NotImplemented = 'Not Implemented',
  BadGateway = 'Bad Gateway',
  ServiceUnavailable = 'Service Unavailable',
  GatewayTimeout = 'Gateway Timeout',
  NetworkError = 'Network Error',
  LoggingOutError = 'Logging Out Error',
  LoginFailed = 'Login failed',
  InvalidRefreshToken = 'Invalid refresh token',
  CancelledError = 'Cancelled request'
}
